import mainConfig from '@/global-routes'

export const hasFooter = (path: string) => {
  return ![
    mainConfig.general.landingPage.path(),
    mainConfig.general.services.path(),
  ].includes(path)
}
